import { combineSlices } from '@reduxjs/toolkit';
import { rmaSlice as coreRmaSlice } from './rma/redux';
import { rmasSlice } from './rmas/redux';

export const rmaReducer = combineSlices(
  coreRmaSlice,
  rmasSlice,
);
